type SeatsSource = {
  seats?: number | null;
  additionalSeats?: number | null;
  vehicleType?: { seats?: number; additionalSeats?: number };
};

function resolveCarSeats(car: SeatsSource) {
  const seats = car.seats ?? car.vehicleType?.seats ?? null;
  const additionalSeats =
    car.seats != null ? (car.additionalSeats ?? 0) : (car.vehicleType?.additionalSeats ?? 0);
  return { seats, additionalSeats };
}

export function formatSeats(
  seats: number | null | undefined,
  additionalSeats?: number | null,
): string {
  if (seats == null) return '';
  return additionalSeats && additionalSeats > 0 ? `${seats}+${additionalSeats}` : String(seats);
}

export function formatCarSeats(car: SeatsSource): string {
  const { seats, additionalSeats } = resolveCarSeats(car);
  return formatSeats(seats, additionalSeats);
}

export function getCarTotalSeats(car: SeatsSource): number {
  const { seats, additionalSeats } = resolveCarSeats(car);
  return (seats ?? 0) + additionalSeats;
}
